const MAP = {
  ON_TRACK: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-400 dark:border-emerald-500/30",
  AT_RISK: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-400 dark:border-amber-500/30",
  CRITICAL: "bg-red-50 text-red-700 border-red-200 dark:bg-red-500/15 dark:text-red-400 dark:border-red-500/30",
};
const LABEL = { ON_TRACK: "On Track", AT_RISK: "At Risk", CRITICAL: "Critical Delay" };

export function HealthBadge({ health, testId, reasons, showReasons = false }) {
  const why = Array.isArray(reasons) ? reasons.filter(Boolean) : [];
  const badge = (
    <span
      data-testid={testId}
      title={why.length ? `Why: ${why.join(". ")}.` : undefined}
      className={`inline-flex items-center whitespace-nowrap rounded-md border px-2.5 py-0.5 text-[11px] font-semibold ${MAP[health] || MAP.CRITICAL}`}
    >
      {LABEL[health] || health || "—"}
    </span>
  );
  if (!showReasons || !why.length) return badge;
  return (
    <div className="space-y-1">
      {badge}
      <ul className="max-w-[240px] space-y-0.5 text-[11px] leading-snug text-muted-foreground" data-testid={testId ? `${testId}-reasons` : undefined}>
        {why.map((r) => <li key={r}>{r}</li>)}
      </ul>
    </div>
  );
}
